import React, { Component } from 'react'
import moment from 'moment'
import { Row, Col, Card, Radio, Progress, Statistic, Icon, DatePicker, Table, Spin, Popover } from 'antd'
import { app } from '../../app'
import asyncComponent from '../../components/asyncComponent'
import utils from '../../utils'
import { getOverview, getUseDetailsList } from './message_api'

const BarReact = asyncComponent(() => import('../../components/Echarts'))  //统计图组件

/**
 * 数值图表数据
 **/
function generateNumEchart(info = []) {
    return {
        backgroundColor: '#fff',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'line',
                lineStyle: {
                    color: '#999'
                }
            },
            borderWidth: 2,
            backgroundColor: 'rgba(255,255,255,.8)',
            borderColor: 'rgba(0,0,0,.4)',
            textStyle: {
                color: '#333'
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
                interval: 'auto',
                color: '#333333',
                fontWeight: '600'
            },
            axisLine: {
                lineStyle: {
                    color: '#c9c9c9'
                }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#c9c9c9'
                }
            },
            data: info.map(f => f.name)
        },
        yAxis: {
            axisLabel: {
                color: '#333333',
                fontWeight: '600'
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#c9c9c9'
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#333333'
                }
            },
            splitNumber: 4,
            minInterval: 1,
            min: 0,
            boundaryGap: ['20%', '20%'],
            axisTick: {
                show: false
            },
            type: 'value'
        },
        series: [
            {
                name: '发送总数',
                type: 'line',
                lineStyle: {
                    color: '#1890ff',
                    shadowColor: 'rgba(24,144,255,0.5)',
                    shadowBlur: 10,
                    shadowOffsetY: 7
                },
                itemStyle: {
                    color: '#1890ff',
                    borderColor: '#1890ff',
                    opacity: 0
                },
                emphasis: {
                    itemStyle: {
                        opacity: 1
                    }
                },
                data: info.map(f => f.total)
            },
            {
                name: '发送成功',
                type: 'line',
                lineStyle: {
                    color: '#19be6b',
                    shadowColor: 'rgba(25,190,107,0.5)',
                    shadowBlur: 10,
                    shadowOffsetY: 7
                },
                itemStyle: {
                    color: '#19be6b',
                    borderColor: '#19be6b',
                    opacity: 0
                },
                emphasis: {
                    itemStyle: {
                        opacity: 1
                    }
                },
                data: info.map(f => f.success)
            },
            {
                name: '发送失败',
                type: 'line',
                lineStyle: {
                    color: '#ff9900',
                    shadowColor: 'rgba(255,153,0,0.5)',
                    shadowBlur: 10,
                    shadowOffsetY: 7
                },
                itemStyle: {
                    color: '#ff9900',
                    borderColor: '#ff9900',
                    opacity: 0
                },
                emphasis: {
                    itemStyle: {
                        opacity: 1
                    }
                },
                data: info.map(f => f.not_success)
            }
        ]
    }
}

class MOverview extends Component {
    constructor(props) {
        super(props)
        this.state = {
            overview: {
                time: moment(),
                margin: {}
            },
            numEchartOptions: {},
            time_type: '2',
            useList: [],
            use_loading: false,
            overview_loading: false,
            use_page: 1,
            use_total: 0,
            start_date: undefined,
            tem_start_date: undefined,
            end_date: undefined,
        }
    }

    async componentDidMount() {
        this._isMounted = true
        await this.overviewDataSource()
        await this.useDataSource()
        // console.log(this.props)
        window.addEventListener('resize', this.handleEchartResize, true)
    }

    componentWillUnmount() {
        this._isMounted = false
        window.removeEventListener('resize', this.handleEchartResize)
    }

    async componentWillReceiveProps(props) {
        if (props.team.key !== this.props.team.key) {
            await this.setData({
                time_type: '2',
                start_date: undefined,
                tem_start_date: undefined,
                end_date: undefined,
                use_total: 0,
                useList: [],
            })
            await this.overviewDataSource()
            await this.useDataSource(1)
        }
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 概览数据
     * @returns {Promise<void>}
     */
    overviewDataSource = async () => {
        await this.setData({ overview_loading: true })
        const { team } = this.props, { time_type, start_date, end_date } = this.state
        const params = {
            type: team.type,
            object_name: team.key,
            month_type: time_type
        }
        if (time_type === '3') {
            params.start_time = start_date ? start_date.format('YYYY-MM-DD') : ''
            params.end_time = end_date ? end_date.format('YYYY-MM-DD') : ''
        }
        const data = await getOverview(params)
        data.time = data.time ? moment(data.time) : moment()
        const margin = { ...data.margin }
        margin.amount = parseInt(margin.number) - parseInt(margin.use_number)
        margin.lv = parseInt(margin.amount / parseInt(margin.number) * 10000) / 100
        data.margin = margin
        await app.sleep(500)
        await this.setData({
            overview_loading: false,
            overview: data,
            numEchartOptions: generateNumEchart(data.dayData)
        })
    }

    /**
     * 图表大小变更
     */
    handleEchartResize = () => {
        this.numChart && this.numChart.resize()
    }

    /**
     * 数据列表
     * @param page
     * @returns {Promise<void>}
     */
    useDataSource = async (page) => {
        const state = { use_loading: true }
        if (page) {
            state.use_page = page
        } else {
            page = this.state.use_page
        }
        await this.setData(state)
        const { team } = this.props
        const { data, total } = await getUseDetailsList({ page, object_name: team.key, type: team.type })
        if (page === this.state.use_page) {
            await this.setData({ useList: utils.addArrayKey(data), use_loading: false, use_total: total })
        }
    }

    /**
     * 修改时间
     **/
    handleChangeTime = async (e) => {
        const { time_type, overview } = this.state, { value } = e.target
        const state = { time_type: value }
        if (value === '3') {
            const time = overview.time
            if (time_type === '1') {
                const date = time.subtract(1, 'month')
                state.start_date = moment(date).date(1)
                state.end_date = date.date(date.daysInMonth())
            } else if (time_type === '2') {
                state.start_date = moment(time).date(1)
                state.end_date = time
            }
            state.tem_start_date = state.start_date
            await this.setData(state)
        } else {
            await this.setData(state)
            await this.overviewDataSource()
        }
    }

    /**
     * 跳转记录
     **/
    handleToRecord = (type) => {
        type && sessionStorage.setItem('message-send-record-status', type)
        this.props.changeSub('4')
    }

    render() {
        let { overview, numEchartOptions, time_type, useList, use_loading, use_page, use_total, start_date, end_date, tem_start_date, overview_loading } = this.state,
            columns = [
                {
                    title: '购买时间',
                    dataIndex: 'send_pay_date',
                    key: 'send_pay_date',
                    width: '15%'
                },
                {
                    title: '购买人',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '15%',
                    render: (vname, { bsrno }) => {
                        return (<span>{vname}（{bsrno}）</span>)
                    }
                },
                {
                    title: '总条数',
                    dataIndex: 'number',
                    key: 'number',
                    width: '12.5%',
                    render: (number) => {
                        return (<Statistic valueStyle={{ fontSize: 12, color: 'rgba(0,0,0,.65)' }}
                            value={parseInt(number)} />)
                    }
                },
                {
                    title: '剩余量(条)',
                    dataIndex: 'use_number',
                    key: 'use_number',
                    width: '12.5%',
                    render: (use_number, { number }) => {
                        return (<Statistic valueStyle={{ fontSize: 12, color: 'rgba(0,0,0,.65)' }}
                            value={parseInt(number) - parseInt(use_number)} />)
                    }
                },
                {
                    title: '生效时间',
                    dataIndex: 'admin_time',
                    key: 'admin_time',
                    width: '15%'
                },
                {
                    title: '失效时间',
                    dataIndex: 'expire_time',
                    key: 'expire_time',
                    width: '15%'
                },
                {
                    title: '状态',
                    dataIndex: 'admin_audit',
                    key: 'admin_audit',
                    width: '15%',
                    render: (status, { refund_cause, gmt_refund_pay, is_expire }) => {
                        let color = '#f1f1f1', text = '未知'
                        switch (status) {
                            case '0':
                                color = '#c5c8ce'
                                text = '未生效'
                                break
                            case '1':
                                if (is_expire === '0') {
                                    color = '#19be6b'
                                    text = '已生效'
                                } else if (is_expire === '1') {
                                    color = '#ff9900'
                                    text = '已失效'
                                }
                                break
                            case '2':
                                color = '#ed4014'
                                text = '已退款'
                                break
                        }
                        return (
                            <div>
                                <span>
                                    <i className="pt-status-circle" style={{ backgroundColor: color }} />
                                    <span>{text}</span>
                                </span>
                                {
                                    status === '2' ? (
                                        <Popover title={(
                                            <div style={{ textAlign: 'center', fontWeight: '600' }}>未通过详细</div>)}
                                            content={(
                                                <div style={{ width: 400 }}>
                                                    <div>
                                                        <div>原因：</div>
                                                        <p style={{ paddingLeft: 10 }}>{refund_cause || '未知'}</p>
                                                    </div>
                                                    <div>退款时间：{gmt_refund_pay || ' - '}</div>
                                                </div>
                                            )} placement="bottomLeft">
                                            <span className="m-link" style={{ marginLeft: 6 }}>详细</span>
                                        </Popover>) : null
                                }
                            </div>
                        )
                    }
                }
            ]
        return (
            <div className="message-overview-page">
                <Card size="small" headStyle={{ backgroundColor: '#F5F6FA' }} bodyStyle={{ padding: 25 }}
                    title="发送量数据"
                    extra={<span>数据获取时间 {overview.time.format('HH:mm:ss')}</span>}>
                    <Row type="flex" align="middle">
                        <Radio.Group value={time_type} buttonStyle="solid" className="no-select"
                            onChange={(e) => this.handleChangeTime(e)}>
                            <Radio.Button value="1">上月</Radio.Button>
                            <Radio.Button value="2">本月</Radio.Button>
                            <Radio.Button value="3">自定义</Radio.Button>
                        </Radio.Group>
                        <span hidden={time_type !== '3'} style={{ marginLeft: 20 }}>
                            {/*<DatePicker*/}
                            {/*disabledDate={(current) => current && current > moment().endOf('day')}*/}
                            {/*format="YYYY-MM-DD"*/}
                            {/*placeholder="开始日期"*/}
                            {/*value={start_date}*/}
                            {/*onChange={this.onStartChange}*/}
                            {/*onOpenChange={this.handleStartOpenChange}*/}
                            {/*/>*/}
                            {/*<DatePicker*/}
                            {/*disabledDate={this.disabledEndDate}*/}
                            {/*format="YYYY-MM-DD"*/}
                            {/*value={end_date}*/}
                            {/*placeholder="End"*/}
                            {/*onChange={this.onEndChange}*/}
                            {/*open={endOpen}*/}
                            {/*onOpenChange={this.handleEndOpenChange}*/}
                            {/*/>*/}
                            {/*<Button>确定</Button>*/}
                            <DatePicker.RangePicker value={start_date && end_date ? [start_date, end_date] : []}
                                disabledDate={current => {
                                    if (current) {
                                        let last_current = current > moment().endOf('day')
                                        let d30 = false
                                        if (tem_start_date) {
                                            d30 = Math.abs(tem_start_date.diff(current, 'days')) > 30
                                        }
                                        return last_current || d30
                                    }
                                    return false
                                }} format="YYYY年MM月DD日" allowClear={false}
                                onCalendarChange={(dates) => this.setData({ tem_start_date: dates[0] })}
                                onChange={async (dates) => {
                                    await this.setData({
                                        start_date: dates[0],
                                        end_date: dates[1]
                                    })
                                    await this.overviewDataSource()
                                }}
                            />
                        </span>
                    </Row>
                    <Spin spinning={overview_loading}>
                        <Row className="mop-number">
                            <Col span={8}>
                                <div className="pn-title">
                                    <i className="nt-dian" style={{ backgroundColor: '#1890ff' }} />
                                    发送总量(条)
                                </div>
                                <div className="pn-count" onClick={() => this.handleToRecord('0')}
                                    style={{ color: '#1890ff' }}>{overview.total || '0'}</div>
                            </Col>
                            <Col span={8}>
                                <div className="pn-title">
                                    <i className="nt-dian" style={{ backgroundColor: '#19be6b' }} />
                                    发送成功量(条)
                                </div>
                                <div className="pn-count" onClick={() => this.handleToRecord('3')}
                                    style={{ color: '#19be6b' }}>{overview.success || '0'}</div>
                            </Col>
                            <Col span={8}>
                                <div className="pn-title">
                                    <i className="nt-dian" style={{ backgroundColor: '#ff9900' }} />
                                    发送未成功(条)
                                </div>
                                <div className="pn-count" onClick={() => this.handleToRecord('2')}
                                    style={{ color: '#ff9900' }}>{overview.not_success || '0'}</div>
                            </Col>
                        </Row>
                        <BarReact option={numEchartOptions} height={316} resize={chart => {
                            this.numChart = chart
                        }} />
                    </Spin>
                </Card>
                <Card size="small" headStyle={{ backgroundColor: '#F5F6FA' }} bodyStyle={{ padding: 0 }}
                    title="国内套餐数据"
                    extra={<span>数据获取时间 {overview.time.format('HH:mm:ss')}</span>}>
                    <Row className="mop-amount">
                        <Col span={12} className="ma-item ma-left">
                            <Progress width={140} type="dashboard" status="active"
                                format={p => (<span style={{ fontSize: 14, fontWeight: 600 }}>
                                    <div style={{ margin: '-25px 0 10px 0' }}>余量</div>
                                    <div style={{ fontSize: 16 }}>{p}%</div></span>
                                )} gapDegree={135} gapPosition="bottom" strokeWidth={8}
                                percent={overview.margin.lv || 0} />
                            <div className="pa-info">
                                <div>可用余量</div>
                                <div className="ai-total">
                                    <Statistic value={overview.margin.amount || '0'} suffix="条" />
                                </div>
                                {/*<Row className="ai-warn" type="flex" justify="space-between">*/}
                                {/*<Col className="iw-1">低于 <b>500</b> 条时预警</Col>*/}
                                {/*<Col><span className="m-link">设置</span></Col>*/}
                                {/*</Row>*/}
                                <div className="ai-warn">
                                    <span>总共：</span>
                                    <Statistic value={overview.margin.number || '0'} suffix="条" />
                                </div>
                            </div>
                        </Col>
                        <Col span={12} className="ma-item">
                            <Row className="ai-content" type="flex" justify="center" align="middle">
                                <Icon type="gift" style={{ color: '#1890ff', fontSize: 72 }} />
                                <ul className="ic-list">
                                    {
                                        (overview.price || []).map((p, i) => (<li key={'omp-' + i}>{p}</li>))
                                    }
                                </ul>
                                <div className="ic-buy" onClick={() => {
                                    this.props.changeSub('2')
                                }}>立即购买
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </Card>
                {/* 概览组件下的短信设置 */}
                {this.props.team.type == 1 ? (<Card size="small" headStyle={{ backgroundColor: '#F5F6FA' }} bodyStyle={{ padding: 0 }}
                    title="短信设置"
                >
                    <Row className="mop-amount" style={{fontSize:19}}>
                        <Col span={23} className="ma-item ma-left" >
                            <Row className="ai-content" type="flex" justify="center" align="middle">
                                <Icon type="setting" style={{ color: '#1890ff', fontSize: 72 }} />
                                <ul className="ic-list">
                                    <li style={{listStyle:'none',marginBottom:20}}>短信自动发送功能上线</li>
                                    <li style={{fontSize:16,marginLeft:20}}>所有队伍可独立设置</li>
                                    <li style={{fontSize:16,marginLeft:20}}>轻松设置、方便快捷</li>
                                </ul>
                                <div className="ic-buy" onClick={() => {
                                    this.props.changeSub('5')
                                }}>前往设置
                                </div>
                            </Row>

                        </Col>
                        
                    </Row>
                </Card>) : ''}
                
                {/* 概览组件下的短信设置end */}
                <Card size="small" headStyle={{ backgroundColor: '#F5F6FA' }} bodyStyle={{ padding: 15 }}
                    title="套餐包使用详情">
                    <Table
                        columns={columns}
                        dataSource={useList}
                        size="small"
                        bordered
                        loading={use_loading}
                        locale={app.tbLocale(use_loading)}
                        className="table-odd-even-row mp-table"
                        pagination={{
                            current: use_page,
                            total: use_total,
                            pageSize: 20,
                            showTotal: (t) => `共${t}条记录.`,
                            onChange: this.useDataSource
                        }}
                    />
                </Card>
            </div>
        )
    }
}

export default MOverview



// WEBPACK FOOTER //
// ./src/routes/message/MOverview.jsx